/* eslint-disable camelcase */
// 引入文件
// import request from '../utils/request';
import { Utils } from 'k7-components';
// import {getUrlParam} from '@/utils/util';
import apiConfig, { headers } from './apiConfig'

const request = Utils.requset

const BASE_ENV = process.env.BASE_ENV,
  baseURL = `//${BASE_ENV === 'prod' ? '' : BASE_ENV + '-'}api.k7.cn/`;

// let userid = getUrlParam('Uid') || (BASE_ENV !== 'prod' && 1146288)
// let key = getUrlParam('Key') || (BASE_ENV !== 'prod' && 'aceeb2a9997e466580f71e562bf2727f')

export function checkRealName(args, loading = 'body')  {
  const url = baseURL + 'account/safety/is_real_name'
  return request.ajaxPromise(url, args, 'get', {
    errMsg: false,
    headers,
    loading,
  })
}
export function getCity(args, loading = 'body')  {
  const url = baseURL + 'game/team/city'
  return request.ajaxPromise(url, args, 'get', {
    errMsg: false,
    headers,
    loading,
  })
}

/**
 *  用户基本信息
 * @method GET
 * @return {[type]}         [description]
 */

export function getBaseinfo(args, loading = 'body') {
  const url = baseURL + 'user/center/baseinfo'
  return request(url, args, 'get', {
    errMsg: false,
    headers,
    loading,
  })
}

/**
 *  用户vip信息
 * @method GET
 * @return {[type]}         [description]
 */

export function getVipinfo(args, loading = 'body') {
  const url = baseURL + 'user/center/vipinfo'
  return request(url, args, 'get', {
    errMsg: false,
    headers,
    loading,
  })
}

/**
 *  用户改名卡数量
 * @method GET
 * @return {[type]}         [description]
 */

export function getRenamecard(args, loading = 'body') {
  const url = baseURL + 'user/center/rename/card'
  return request(url, args, 'get', {
    errMsg: false,
    headers,
    loading,
  })
}
/**
 *  获取用户背包物品
 * @method GET
 * @return {[type]}         [description]
 */

export function getIteminfo(args, loading = 'body') {
  const url = baseURL + 'user/center/iteminfo'
  return request(url, args, 'get', {
    errMsg: false,
    headers,
    loading,
  })
}
// export function getIteminfo(page_index, page_size) {
//   return request({
//     url: baseURL + 'user/center/iteminfo',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key
//     },
//     method: 'GET',
//     params: {
//       page_index,
//       page_size
//     }
//   })
// }

/**
 *  修改账号密码
 * @method PUT
 * @return {[type]}         [description]
 */

export function putAccountPassword(args, loading = 'body') {
  const url = baseURL + 'user/center/update/account/password'
  return request(url, args, 'put', {
    errMsg: false,
    headers,
    loading,
  })
}

// export function putAccountPassword(account, password) {
//   return request({
//     url: baseURL + 'user/center/update/account/password',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key
//     },
//     method: 'PUT',
//     data: {
//       account,
//       password,
//     }
//   })
// }

/**
 *  修改保险箱密码
 * @method PUT
 * @return {[type]}         [description]
 */

export function putBankPassword(args, loading = 'body') {
  const url = baseURL + 'user/center/update/bank/password'
  return request(url, args, 'put', {
    errMsg: false,
    headers,
    loading,
  })
}
// export function putBankPassword(password) {
//   return request({
//     url: baseURL +  'user/center/update/bank/password',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key
//     },
//     method: 'PUT',
//     data: {
//       password
//     }
//   })
// }

/**
 *  获取用户登录日志
 * @method GET
 * @return {[type]}         [description]
 */

export function getLoginlog(args, loading = 'body') {
  const url = baseURL + 'user/center/login/log'
  return request(url, args, 'get', {
    errMsg: false,
    headers,
    loading,
  })
}
// export function getLoginlog() {
//   return request({
//     url: baseURL + 'user/center/login/log',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key
//     },
//     method: 'GET'
//   })
// }

/**
 *  校验昵称是否重复
 * @method GET
 * @return {[type]}         [description]
 */

export function getNickname(args, loading = 'body') {
  const url = baseURL + 'user/nickname'
  return request(url, args, 'get', {
    errMsg: false,
    headers: { action: 'check', ...headers },
    loading,
  })
}

// export function getNickname(nickName) {
//   return request({
//     url: baseURL + 'user/nickname',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key,
//       action: 'check'
//     },
//     method: 'GET',
//     params: {
//       nickName
//     }
//   })
// }

/**
 *  修改昵称
 * @method PUT
 * @return {[type]}         [description]
 */

export function putNickname(args, loading = 'body') {
  const url = baseURL + 'user/nickname'
  return request(url, args, 'put', {
    errMsg: false,
    headers: { action: 'update', ...headers },
    loading,
  })
}

// export function putNickname(new_nickname) {
//   return request({
//     url: baseURL + 'user/nickname',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key,
//       action: 'update'
//     },
//     method: 'PUT',
//     data: {
//       new_nickname
//     }
//   })
// }

/**
 *  每日月卡奖励是否领取
 * @method GET
 * @return {[type]}         [description]
 */

export function getMonthCard(args, loading = 'body') {
  const url = baseURL + 'user/center/month_card'
  return request(url, args, 'get', {
    errMsg: false,
    headers: { action: 'receive', ...headers },
    loading,
  })
}

// export function getMonthCard() {
//   return request({
//     url: baseURL + 'user/center/month_card',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key,
//       action: 'receive'
//     },
//     method: 'GET'
//   })
// }

/**
 *  每日vip奖励是否领取
 * @method GET
 * @return {[type]}         [description]
 */

export function getVip(args, loading = 'body') {
  const url = baseURL + 'user/center/vip'
  return request(url, args, 'get', {
    errMsg: false,
    headers: { action: 'check', ...headers },
    loading,
  })
}

// export function getVip() {
//   return request({
//     url: baseURL +  'user/center/vip',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key,
//       action: 'receive'
//     },
//     method: 'GET'
//   })
// }

/**
 *  发送手机短信验证码
 * @method POST
 * @return {[type]}         [description]
 */

export function postMmsCode(args, loading = 'body') {
  const url = baseURL + 'user/sms_code'
  return request(url, args, 'post', {
    errMsg: false,
    headers: { action: 'send', ...headers },
    loading,
  })
}

// export function postMmsCode(phone_num) {
//   return request({
//     url: baseURL + 'user/sms_code',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key,
//       action: 'send'
//     },
//     method: 'POST',
//     data: {
//       phone_num,
//       type: 'security'
//     }
//   })
// }

/**
 *  修改密码前手机验证
 * @method GET
 * @return {[type]}         [description]
 */

export function getTelVerify(args, loading = 'body') {
  const url = baseURL + 'user/center/password/tel_verify'
  return request(url, args, 'get', {
    errMsg: false,
    headers,
    loading,
  })
}

// export function getTelVerify(code, phoneNum) {
//   return request({
//     url: baseURL + 'user/center/password/tel_verify',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key
//     },
//     method: 'GET',
//     params: {
//       code,
//       phoneNum
//     }
//   })
// }

/**
 *  获取用户地址
 * @method GET
 * @return {[type]}         [description]
 */

export function getAddress(args, loading = 'body') {
  const url = baseURL + 'user/center/receiver/address'
  return request(url, args, 'get', {
    errMsg: false,
    headers,
    loading,
  })
}

// export function getAddress() {
//   return request({
//     url: baseURL + 'user/center/receiver/address',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key
//     },
//     method: 'GET'
//   })
// }

/**
 *  修改用户地址
 * @method PUT
 * @return {[type]}         [description]
 */

export function putAddress(args, loading = 'body') {
  const url = baseURL + 'user/center/receiver/address'
  return request(url, args, 'put', {
    errMsg: false,
    headers: { action: 'update', ...headers },
    loading,
  })
}

// export function putAddress(area_id, delivery_to_name, complete_address, contact_number) {
//   return request({
//     url: baseURL + 'user/center/receiver/address',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key,
//       action: 'update'
//     },
//     method: 'PUT',
//     data: {
//       area_id,
//       complete_address,
//       contact_number,
//       delivery_to_name,
//     }
//   })
// }

/**
 *  获取用户充值记录
 * @method GET
 * @return {[type]}         [description]
 */

export function getOrderList(args, loading = 'body') {
  const url = baseURL + 'recharge/pc/order_list'
  return request(url, args, 'get', {
    errMsg: false,
    headers,
    loading,
  })
}

// export function getOrderList() {
//   return request({
//     url: baseURL + 'recharge/pc/order_list',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key
//     },
//     method: 'GET'
//   })
// }

/**
 *  上传头像
 * @method POST
 * @return {[type]}         [description]
 */

export function postFace(args, loading = 'body') {
  const url = baseURL + 'user/center/face/modify'
  return request(url, args, 'post', {
    errMsg: false,
    headers: { action: 'base64', ...headers },
    loading,
  })
}
// export function postFace(face_id, face_image, face_type) {
//   return request({
//     url: baseURL + 'user/center/face/modify',
//     headers: {
//       'x-k7-userid': userid,
//       'x-k7-sessionkey': key,
//       action: 'base64'
//     },
//     method: 'POST',
//     data: {
//       face_id,
//       face_image,
//       face_type
//     }
//   })
// }
